import { render, staticRenderFns } from "./SubdomainForm.vue?vue&type=template&id=32c688a8&scoped=true&"
import script from "./SubdomainForm.vue?vue&type=script&lang=js&"
export * from "./SubdomainForm.vue?vue&type=script&lang=js&"
import style0 from "./SubdomainForm.vue?vue&type=style&index=0&id=32c688a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c688a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardTitle})
